<template>
  <transition :name="transition">
    <div
      :style="{zIndex: zIndex}"
      class="backdrop"
      @click="handleClick"
      v-show="value"
    >
      <slot></slot>
    </div>
 </transition>
</template>

<script>
export default {
  name: 'backdrop',
  props: {
    value: Boolean,
    zIndex: {
      type: Number,
      default: 1000
    },
    transition: {
      type: String,
      default: 'backdrop'
    }
  },
  methods: {
    handleClick () {
      this.$emit('click');
    }
  }
};
</script>

<style src="./index.css"></style>



// WEBPACK FOOTER //
// src/components/backdrop/index.vue